addEventListener("DOMContentLoaded", (event) => {
    const openMenuButton = document.querySelector(".mobile-menu-button");
    const closeMenuButton = document.querySelector(".close-mobile-menu");
    const mobileMenu = document.querySelector(".mobile-menu");
    const body = document.querySelector("body");

    openMenuButton.addEventListener("click", () => {
        mobileMenu.classList.add("active");
        body.classList.add("backdrop-is-active");
    });

    closeMenuButton.addEventListener("click", () => {
        mobileMenu.classList.remove("active");
        body.classList.remove("backdrop-is-active");
    });
});
